import { inject, Injectable } from '@angular/core';
import { AuthService } from '../services/Auth/auth-service';
import { Router, UrlTree } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
// export class Guard {
//   constructor(private authService: AuthService, private router: Router) { }

//   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
//     return this.authService.isLoggedIn()
//       ? true
//       : this.router.createUrlTree(['/login-new']);
//   }
// }

// @Injectable({
//   providedIn: 'root'
// })
// export class UrlRestrictionGuard {
//   constructor(private authService: AuthService, private router: Router) { }

//   canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
//     const restrictedUrls = ['/people', '/settings'];
//     // const user = this.authService.getUser();

//     if (this.authService.isLoggedIn()) {
//       if (restrictedUrls.some(url => state.url.startsWith(url))) {
//         // if (user?.role === 'admin') {
//         //   return true;
//         // }
//         return this.router.createUrlTree(['/unauthorized']);
//       }
//       return true;
//     }

//     return this.router.createUrlTree(['/login-new'], { queryParams: { redirectURL: state.url } });
//   }
// }


//test
export class Guard {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    
    // Check if user is authenticated
    if (this.authService.isLoggedIn()) {
      return true;
    }

    
    // Store the attempted URL for redirect after login
    const redirectUrl = state.url;
    if (redirectUrl !== '/login') {
      localStorage.setItem('redirectUrl', redirectUrl);
    }
    
    // Redirect to login page
    return this.router.createUrlTree(['/login']);
  }
}

@Injectable({
  providedIn: 'root'
})
export class UrlRestrictionGuard {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    
    const restrictedUrls = ['/people', '/settings'];
    
    // First check if user is authenticated
    if (!this.authService.isLoggedIn()) {
      return this.router.createUrlTree(['/login'], { 
        queryParams: { redirectURL: state.url } 
      });
    }

    // Check if the URL is restricted
    if (restrictedUrls.some(url => state.url.startsWith(url))) {
      const user = this.authService.getUser();
      
      // Check if user has admin role (you can customize this logic)
      if (user?.utype === 'Admin' || user?.accesslevel === 'admin') {
        return true;
      }
      return this.router.createUrlTree(['/unauthorized']);
    }
    return true;
  }
}

@Injectable({
  providedIn: 'root'
})
export class LoginGuard {
  private authService = inject(AuthService);
  private router = inject(Router);

  canActivate(
    route: ActivatedRouteSnapshot, 
    state: RouterStateSnapshot
  ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    
    // If user is already logged in, redirect to dashboard or stored redirect URL
    if (this.authService.isLoggedIn()) {
      const redirectUrl = localStorage.getItem('redirectUrl');
      
      if (redirectUrl && redirectUrl !== '/login') {
        localStorage.removeItem('redirectUrl');
        return this.router.createUrlTree([redirectUrl]);
      } else {
        return this.router.createUrlTree(['/projects']);
      }
    }
    
    // Allow access to login page if not authenticated
    return true;
  }
}